import { useEffect } from "react";
import { Store, Van } from "lucide-react";
import { useDispatch, useSelector } from "react-redux";
import {
  setDeliveryType,
  setPickupLocation,
  setPickupLock,
} from "../modules/delivery/actions";
import { DELIVERY_ADDRESS, DELIVERY_PICKUP } from "../modules/delivery/reducer";
import AddressDelivery from "./addressDelivery";
import Pickup from "./pickup";
import SelectionTiles from "./selectionTiles";
import {
  forgetPickupLink,
  getRememberedPickupLink,
} from "../utils/pickupLinkSession";

function Delivery() {
  const deliveryType = useSelector((state) => state.delivery.type);
  const pickupLocked = useSelector((state) => state.delivery.pickup_locked);
  const { deliveryTypes, pickupLocations } = useSelector(
    (state) => state.store
  );
  const dispatch = useDispatch();

  useEffect(() => {
    const pickupHash = getRememberedPickupLink();
    if (!pickupHash || !pickupLocations.length) return;

    const pickupLocation = pickupLocations.find(
      (location) => location.hash === pickupHash
    );
    if (!pickupLocation) {
      forgetPickupLink();
      dispatch(setPickupLock(false));
      return;
    }

    dispatch(setDeliveryType(DELIVERY_PICKUP));
    dispatch(setPickupLocation(pickupLocation.id));
    dispatch(setPickupLock(true));
  }, [dispatch, pickupLocations]);

  useEffect(() => {
    if (!deliveryType && deliveryTypes.length === 1) {
      dispatch(setDeliveryType(deliveryTypes[0]));
    }
  }, [deliveryType, deliveryTypes, dispatch]);

  if (!deliveryTypes) {
    return <div className="text-center">Bez możliwość odbioru lub dowozu</div>;
  }

  const deliveryOptions = [
    {
      value: DELIVERY_PICKUP,
      label: "Odbiór",
      ariaLabel: "Odbiór osobisty",
      icon: (
        <Store
          className="selection-tile__icon"
          strokeWidth={1.8}
          aria-hidden="true"
        />
      ),
    },
    {
      value: DELIVERY_ADDRESS,
      label: "Dowóz",
      ariaLabel: "Dowóz pod adres",
      icon: (
        <Van
          className="selection-tile__icon"
          strokeWidth={1.8}
          aria-hidden="true"
        />
      ),
    },
  ].filter(({ value }) => deliveryTypes.includes(value));

  return (
    <>
      {!pickupLocked && (
        <div key="delivery-type" className="delivery-type-selector">
          <span className="interface-label">Sposób dostawy</span>
          <SelectionTiles
            ariaLabel="Wybierz sposób dostawy"
            fill
            layout="horizontal"
            options={deliveryOptions}
            value={deliveryType}
            onChange={(value) => dispatch(setDeliveryType(value))}
            renderOption={({ icon, label }) => (
              <>
                {icon}
                <span className="selection-tile__label">{label}</span>
              </>
            )}
          />
        </div>
      )}
      {deliveryType && (
        <div className="mt-2">
          {deliveryType === DELIVERY_ADDRESS && <AddressDelivery />}
          {deliveryType === DELIVERY_PICKUP && <Pickup />}
        </div>
      )}
    </>
  );
}

export default Delivery;
